// some browser behaviors like autofill, autocomplete navigation, etc can dispatch a synthetic keydown
//
// callers should ignore these to avoid "garbage in"
//
// prior art examples:
// - https://github.com/jamiebuilds/tinykeys/blob/9f321b0d1e556d737b418d7a1e8c1770ef63a6aa/src/tinykeys.ts#L118-L128
// - https://github.com/JohannesKlauss/react-hotkeys-hook/blob/aa8b6d06dad296a6c3325916b47c042c35eecc0c/packages/react-hotkeys-hook/src/lib/isHotkeyPressed.ts#L5-L7
export function isSyntheticEvent(e: KeyboardEvent) {
  return !(e.key && e.code && e.getModifierState);
}
